import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import './Pages.css';

const ContactPage = () => {
  const [formData, setFormData] = useState({ name: '', email: '', phone: '', message: '' });
  const [feedback, setFeedback] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!formData.name || !formData.email.includes('@') || !formData.message) {
      setFeedback({ message: ' Please fill in all required fields correctly.', type: 'error' });
      setTimeout(() => setFeedback({ message: '', type: '' }), 3000);
      return;
    }

    setIsLoading(true);
    setFeedback({ message: 'Sending message...', type: 'info' });

    try {
      const SERVICE_ID = 'service_slgl0va';
      const ADMIN_TEMPLATE_ID = 'template_ddfee6n';      // Your admin notification template
      const AUTO_REPLY_TEMPLATE_ID = 'template_hrxxoz3'; //  Your auto-reply template ID
      const PUBLIC_KEY = 'yqt4FqZ4H7jD7UIda';

      // 1. Send email to ADMIN (you)
      const adminParams = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone || 'Not provided',
        message: formData.message,
      };

      console.log('Sending admin email...');
      await emailjs.send(SERVICE_ID, ADMIN_TEMPLATE_ID, adminParams, PUBLIC_KEY);
      console.log('Admin email sent successfully');

      // 2. Send AUTO-REPLY to the customer
      const autoReplyParams = {
        name: formData.name,
        email: formData.email,
        message: formData.message,
      };

      console.log('Sending auto-reply to:', formData.email);
      await emailjs.send(SERVICE_ID, AUTO_REPLY_TEMPLATE_ID, autoReplyParams, PUBLIC_KEY);
      console.log('Auto-reply sent successfully');
      
      setFeedback({ message: 'Akpe kakaka! Medaase! Your message has been sent. A confirmation email has been sent to your inbox.', type: 'success' });
      setFormData({ name: '', email: '', phone: '', message: '' });
    } catch (error) {
      console.error('Full error:', error);
      setFeedback({ message: ` Error: ${error.text || 'Please try again'}`, type: 'error' });
    } finally {
      setIsLoading(false);
      setTimeout(() => setFeedback({ message: '', type: '' }), 5000);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="container fade-in-up">
      <div className="section-title">Connect With Us Today</div>
      
      <div className="contact-wrapper">
        <div className="contact-info">
          <h3><i className="fas fa-map-pin"></i> Get In Touch</h3>
          <p><i className="fas fa-envelope"></i> nojokelotterycompany@gmail.com</p>
          <p><i className="fas fa-phone-alt"></i> +233 (0) 24 680 4253</p>
          <p><i className="fas fa-clock"></i> Mon-Sun: 8AM - 10PM (GMT)</p>
          <p><i className="fas fa-globe"></i> 24/7 Live Support via chat</p>
          
          <div className="address-block">
            <h4><i className="fas fa-location-dot"></i> Headquarters:</h4>
            <p className="justify-text">No Joke Lottery Company Limited<br />Denu Tokor, Near St. Paul's Senior High School<br />Volta Region, Ghana</p>
          </div>
        </div>

        <div className="contact-form">
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <input 
                type="text" 
                name="name" 
                placeholder="Full Name *" 
                value={formData.name} 
                onChange={handleChange} 
                required 
              />
            </div>
            <div className="form-group">
              <input 
                type="email" 
                name="email" 
                placeholder="Email Address *" 
                value={formData.email} 
                onChange={handleChange} 
                required 
              />
            </div>
            <div className="form-group">
              <input 
                type="tel" 
                name="phone" 
                placeholder="Phone Number (Optional)" 
                value={formData.phone} 
                onChange={handleChange} 
              />
            </div>
            <div className="form-group">
              <textarea 
                name="message" 
                rows="4" 
                placeholder="Your message... *" 
                value={formData.message} 
                onChange={handleChange}
                required
              ></textarea>
            </div>
            <button type="submit" className="btn-primary" disabled={isLoading}>
              {isLoading ? (
                <>Sending... <i className="fas fa-spinner fa-pulse"></i></>
              ) : (
                <>Send Message <i className="fas fa-paper-plane"></i></>
              )}
            </button>
            {feedback.message && (
              <p className={`form-feedback ${feedback.type}`}>{feedback.message}</p>
            )}
          </form>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;